<template>
  <div class="bills-create-page">
    <div class="content-header">
      <div class="container-fluid">

        <div class="d-flex justify-content-between">
          <h4 class="font-weight-light">
            <span class="font-weight-bold">บิล</span>
          </h4>

          <!-- <button v-if="billDetails.status === 2 && "
                  type="button"
                  class="btn btn-primary btn-md"
                  data-toggle="modal"
                  data-target="#print-receipts"
                  :disabled="receiptPrintLoading">
            Print receipt
          </button> -->

          <Button v-if="!pageLoading"
                  type="button"
                  variant="primary"
                  @click="handleReceiptPrint()"
                  :loading="receiptPrintLoading"
                  :disabled="receiptPrintLoading"
                  size="md">
            พิมพ์ใบเสร็จรับเงิน
          </Button>

        </div>
      </div>
    </div>

    <div class="content">
      <div class="container-fluid">

        <Spinner size="md"
                 v-if="pageLoading" />
        <div class="row"
             v-else>
          <div class="col-12 col-md-6">
            <Card>
              <div slot="body">
                <p>หมายเลขบิล: {{ billDetails.billNo }}</p>
                <p>ลูกค้า: {{ billDetails.shipper ? billDetails.shipper.name : "..." }}</p>
                <hr>

                <div class="d-flex justify-content-between">
                  <div>
                    <p class="lead">จำนวนพัสดุ: {{ totalShipments }}</p>
                    <p class="lead">ค่าส่งรวม: {{ totalPrice }}</p>
                  </div>

                  <div class="mt-2">
                    <span
                          :class="`badge badge-pill text-uppercase status-badge --${getBillStatus(billDetails.status).variation}`">
                      {{ getBillStatus(billDetails.status).title }}
                    </span>
                  </div>
                </div>


                <hr>

                <p class="lead mt-2">รายการจัดส่ง</p>
                <table class="table _datatable bills-table --very-small-height">
                  <thead>
                    <tr>
                      <th>เลขแทร็ค</th>
                      <th>น้ำหนัก</th>
                      <th>ราคา</th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="order in billDetails.orders"
                        :key="order.trackingNo">
                      <td>{{ order.trackingNo }}</td>
                      <td>{{ order.weight }}</td>
                      <td>{{ order.price }}</td>
                      <td>
                        <Button type="button"
                                :variant="orderDetails.id === order.id ? 'primary' : 'default'"
                                @click="initOrderDetails(order)"
                                size="sm">
                          <i class="fal fa-eye"></i>
                        </Button>

                        <button type="button"
                                data-toggle="modal"
                                data-target="#orders-print-labels"
                                @click="() => {
                                  printUrl = null;
                                  printOrderId = `${order.id}__${order.createdAt}`;
                                }"
                                class="btn btn-link btn-sm text-color-5 p-0 ml-2">
                          <i class="fal fa-print"></i>
                        </button>

                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Card>
          </div>

          <div class="col-12 col-md-6">
            <Card>
              <div slot="body">
                <div v-if="orderDetails">
                  <div class="d-flex justify-content-between mb-4">
                    <h5>{{ orderDetails.trackingNo }}</h5>
                    <h5>{{ orderDetails.createdAt | formatDate }}</h5>
                  </div>

                  <p class="mt-2">ชื่อผู้รับ: {{ orderDetails.name }}</p>
                  <p class="mt-2">{{ $t('general.phone') }}: {{ orderDetails.phoneNo }}</p>
                  <p class="mt-2">ที่อยู่ผู้รับ: {{ orderDetails.addr }}</p>
                  <p class="mt-2">อำเภอ/เขต: {{ orderDetails.dist }}</p>
                  <p class="mt-2">ตำบล/แขวง: {{ orderDetails.subDist }}</p>
                  <p class="mt-2">จังหวัด: {{ orderDetails.prov }}</p>
                  <p class="mt-2">รหัสปณ.: {{ orderDetails.zip }}</p>
                  <p class="mt-2">COD: {{ orderDetails.cod }}</p>
                  <p class="mt-2">น้ำหนัก: {{ orderDetails.weight }}</p>
                  <p class="mt-2">ราคาที่คิดลูกค้า: {{ orderDetails.price }}</p>
                  <p class="mt-2">ส่วนลด: {{ orderDetails.discount }}</p>
                  <p class="mt-2">หมายเลขอ้างอิง.: {{ orderDetails.refNo }}</p>
                  <p class="mt-2">หมายเหตุ: {{ orderDetails.note }}</p>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>

    <Modal id="orders-print-labels"
           custom_dialog_class="modal-dialog-centered"
           :backdrop="true">
      <template slot="body"
                v-if="printLabels">

        <div class="d-flex justify-content-between mb-4">
          <p class="lead text-center align-self-center">

            <span v-if="printLabelLoading">
              กำลังพิมพ์ใบปะหน้าจำนวน {{ billDetails.orders.length }} ใบ
            </span>

            <span v-else-if="printUrl">
              ใบปะหน้าพร้อมแล้ว {{ billDetails.orders.length }} ใบ
            </span>

            <span v-else>
              {{ $t("shipment.shipping_label.message") }}
            </span>
          </p>

          <button id="btn-close-print-dialog"
                  class="btn btn-default btn-sm"
                  data-dismiss="modal"
                  :disabled="printLabelLoading">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <div class="alert alert-success mb-2"
             v-if="printLabelLoading"
             style="font-size: 1rem">
          {{ $t("print_dialog.generating_link") }}
        </div>

        <div class="text-center mb-2 mt-2"
             id="print-message"
             v-if="printUrl">
          <a :href="printUrl"
             target="_blank"
             rel="noopener noreferrer"
             class="btn btn-success mr-2">
            {{ $t("print_dialog.click_to_download") }}
          </a>
        </div>

        <div class="d-flex flex-column"
             v-else-if="!printLabelLoading && !printUrl">
          <!-- Paper size selector -->
          <div class="flex-grow-1">
            <label>โปรดเลือกขนาดกระดาษที่ต้องการใช้งาน</label>
            <select class="form-control form-control-sm"
                    v-model="selectedPaperSize"
                    @change="setPaperSize">
              <option :value="paperSize"
                      v-for="paperSize in Object.keys(printLabels.paperSizes)"
                      :key="paperSize">
                {{ paperSize }}
              </option>
            </select>
          </div>

          <!-- print selector -->
          <div class="d-flex flex-wrap printerFormatContainer mt-4">
            <div class="printerFormat"
                 v-for="(prtFr, index) in printLabels.paperSizes[selectedPaperSize]"
                 :key="index"
                 @click="handleOrdersPrint(prtFr.size, prtFr.printer)">
              <div>
                <div class="d-flex">
                  <img :src="prtFr.image"
                       class="icon align-self-start" />
                  <div class="d-flex flex-column align-self-center">
                    <p class="mb-0 --text-vsm">{{ prtFr.name }}</p>
                    <p class="--text-vsm text-color-5 mt-n2"
                       v-if="prtFr.sizeToShow">
                      {{ prtFr.sizeToShow }}
                    </p>
                  </div>
                </div>

                <p class="--text-vvsm text-color-5">{{ prtFr.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Modal>

    <Modal id="print-receipts"
           custom_dialog_class="modal-dialog-centered"
           :backdrop="true">
      <template slot="body">

        <h4 class="mb-4"> <i class="fal fa-print mr-2"> </i>Print bil receipt</h4>
        <div class="d-flex align-items-center">
          <p class="lead text-nowrap mr-2">Amount received: </p>
          <NumberField id="amount"
                       wrapper_class="mb-0 pb-0"
                       fg_wrapper_class="mb-0 pb-0"
                       v-model="billDetails.custAmt" />
        </div>

        <div class="d-flex justify-content-end mt-5">
          <button id="btn-close-print-dialog"
                  class="btn btn-secondary btn-sm mr-2"
                  data-dismiss="modal"
                  :disabled="printLabelLoading">
            Close
          </button>
          <Button v-if="billDetails.custAmt"
                  type="button"
                  variant="primary"
                  @click="handleReceiptPrint()"
                  :loading="receiptPrintLoading"
                  :disabled="receiptPrintLoading"
                  size="md">
            Print
          </Button>
        </div>
      </template>
    </Modal>

  </div>
</template>

<script>
import Card from "@/components/core/Card";
import Spinner from "@/components/core/Spinner";
import Modal from "@/components/core/Modal";
import Button from "@/components/core/Button";
import NumberField from "@/components/core/NumberField";
import { getBillStatus } from "@/helpers/core";
import { printLabels } from "@/helpers/print";
import { printReceipt } from "@/helpers/receiptPrint";
import Vue from "vue";

export default {
  name: "Seller-Bill-Create",
  components: {
    Card,
    Spinner,
    Button,
    Modal,
    NumberField
  },
  data() {
    return {
      printLabelLoading: false,
      printLabels: null,
      printLoading: false,
      selectedPaperSize: localStorage.getItem("paperSize"),
      printUrl: null,
      printOrderId: null,

      shippers: [],

      pageLoading: false,
      ordersListLoading: false,
      ordersPrintLoading: false,
      receiptPrintLoading: false,

      billDetails: {
        billNo: null,
        shipper: null,
        custAmt: null,
        orders: [],
      },

      orderDetails: null,
      shop: null
    };
  },

  async created() {
    if (this.$route.params.billNo) {
      this.pageLoading = true;
      const { status, data } = await this.$store.dispatch("bills/fetchBillDetail", {
        billNo: this.$route.params.billNo
      })
      if (status) {
        this.billDetails = data;
        if (this.billDetails.shipperId) await this.fetchShipper(this.billDetails.shipperId);
        if (this.billDetails.orders && this.billDetails.orders.length) {
          this.initOrderDetails(this.billDetails.orders[0])
        }
      }
      this.pageLoading = false;
    }

    // print
    this.printLabels = printLabels()

    // fetch acount details..for receipt
    const { status, data } = await this.$store.dispatch("settings/fetchSetting", {
      type: "account"
    });
    if (status) Vue.set(this.billDetails, "shop", data);
  },

  mounted() {
  },

  methods: {

    async handleOrdersPrint(size, printer) {
      this.printLabelLoading = true;
      this.printUrl = null;
      const { status, data } = await this.$store.dispatch("print/printLabels", {
        req: {
          printer,
          size,
          orders: [this.printOrderId],
          shipper: {
            name: this.billDetails.shipper.name,
            idCard: this.billDetails.shipper.idCard,
            phoneNo: this.billDetails.shipper.phoneNo,
            walletId: this.billDetails.shipper.walletId,
            addr: this.billDetails.shipper.addr,
            dist: this.billDetails.shipper.dist,
            subDist: this.billDetails.shipper.subDist,
            prov: this.billDetails.shipper.prov,
            zip: this.billDetails.shipper.zip
          }
        }
      });
      if (status) {
        this.printUrl = data.url;
      }

      this.printLabelLoading = false;
    },

    setPaperSize() {
      localStorage.setItem("paperSize", this.selectedPaperSize);
      this.printUrl = null;
    },

    getBillStatus(status) {
      return getBillStatus(status)
    },

    async fetchShipper(id) {
      const { status, data } = await this.$store.dispatch("shippers/fetchShipper", { id });
      if (status) Vue.set(this.billDetails, "shipper", data);
    },

    initOrderDetails(order) {
      if (order) this.orderDetails = JSON.parse(JSON.stringify(order));
    },

    async handleReceiptPrint() {
      // this.receiptPrintLoading = true;
      // this.printUrl = null;
      // const { status, data } = await this.$store.dispatch("print/printReceipt", {
      //   req: {
      //     printer: "receipt",
      //     billNo: this.billDetails.billNo,
      //     orders: this.billDetails.orders,
      //     shipper: this.billDetails.shipper,
      //     custAmt: this.billDetails.custAmt,
      //     status: this.billDetails.status
      //   }
      // });
      // if (status) {
      //   if (data.url) window.open(data.url, '_blank').focus();
      // }
      // this.receiptPrintLoading = false;

      printReceipt(this.billDetails);
    }
  },

  computed: {
    totalShipments() {
      return this.billDetails.orders ? this.billDetails.orders.length : 0;
    },

    totalPrice() {
      let price = 0;
      if (this.billDetails.orders && this.billDetails.orders.length) {
        price = this.billDetails.orders.reduce((acc, o) => acc + o.price, 0) - this.billDetails.orders.reduce((acc, o) => acc + (o.discount || 0), 0);
      }
      return price;
    },
  },
};
</script>

<style lang="scss" scoped>
.printerFormatContainer {
  width: 210px;

  @include for-larger-than-phone {
    width: 420px;
  }

  margin: 0 auto;
  overflow: auto;

  .printerFormat {
    width: 200px;
    background-color: rgb(252, 252, 252);
    padding: 0.25rem;
    border-radius: 3px;
    margin: 0.25rem;
    cursor: pointer;

    &:hover {
      background-color: whitesmoke;
    }

    .icon {
      height: 1rem;
      width: auto;
      margin-right: 0.5rem;
      margin-top: 0.4rem;
    }
  }
}
</style>
